export const Teamdata = {
  employees: [
    { name: 'John Doe', image: "/images/emp2.png" },
    { name: 'Jane Smith', image: "/images/emp3.png" },
    { name: 'Bob Johnson', image: "images/emp7.png" },
    { name: 'Sarah Lee', image: "/images/emp9.png" },
    { name: 'Tom Wilson', image: "/images/emp8.png" },
    { name: 'Sarah Lee', image: "/images/emp6.png" },
    { name: 'Sarah Lee', image: "images/emp4.png" },
    { name: 'Sarah Lee', image: "images/emp5.png" },
  ],
  
};
